import { createFileRoute } from "@tanstack/react-router";
import AdminDashboard from "@/pages/admin/AdminDashboard";

export const Route = createFileRoute("/_adminLayout/admin/")({
  head: () => ({
    meta: [
      { title: "Dashboard | Rex & Sons RVs Admin" },
      { name: "description", content: "Rex & Sons RVs administration dashboard for inventory, leads and visitor reporting." },
      { property: "og:title", content: "Dashboard | Rex & Sons RVs Admin" },
      { property: "og:description", content: "Rex & Sons RVs inventory, leads and visitor reporting dashboard." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: AdminDashboard,
});
